import gql from 'graphql-tag'

export default gql`
query event($slug: String!) {
  event(slug: $slug)
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/event.js